module.exports = __webpack_public_path__ + "c6f932b7e90d48f998af1b21d5255e72.svg";